import { useMedia } from 'helpers/hooks/useMedia'
import { useEffect } from 'react'
import {
  mediaDesktopAndUp,
  mediaTabletAndDown,
} from 'uiComponents/constants/customMedia'
import RowBuilder from 'uiComponents/molecules/TileGrid/RowBuilder'

export const useResponsiveRowBuilder = (rowBuilder: RowBuilder) => {
  const tilesPerRow = useMedia(
    {
      [mediaDesktopAndUp]: 3,
      [mediaTabletAndDown]: 2,
    },
    3,
  )
  useEffect(() => {
    rowBuilder.updateTilesPerRow(tilesPerRow)
  }, [tilesPerRow, rowBuilder])
}
